module.exports = __webpack_public_path__ + "static/media/promotion-tag.1578e9e2.svg";